import react from 'react';
import { Box, Container, Grid } from '@mui/material';       


function Servicecard ({image, name }){
    return(
        <>
            
            <div className='serviceCard'>
                <img src={image} alt={name} />
                <h3>{name}</h3>
            </div>
        </>
    )
}

export default Servicecard;